import { useState } from "react";
import {
  ConnectAccountOnboarding,
  ConnectComponentsProvider,
} from "@stripe/react-connect-js";
import { useNavigate } from "react-router-dom";
import useStripeConnect from "../../../utils/hooks/useStripeConnect";
import { AuthServices } from "../services/AuthServices";
import useUpdateOnboardingStatus from "../../../utils/hooks/useUpdateOnboardingStatus";

const StripeSetup = ({ setStep }) => {
  const navigate = useNavigate();
  const [error, setError] = useState(false);
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const updateOnboardingStatus = useUpdateOnboardingStatus();
  const [connectedAccountId, setConnectedAccountId] = useState();
  const [onboardingExited, setOnboardingExited] = useState(false);
  const stripeConnectInstance = useStripeConnect(connectedAccountId);
  const [accountCreatePending, setAccountCreatePending] = useState(false);

  const handleExit = async () => {
    setOnboardingExited(true);
    const applicationNumber = Math.random();
    const response =
      await AuthServices.updateApplicationNumber(applicationNumber);
    if (response.data?.status === 401) {
      navigate("/register/account-setup");
      return;
    }

    const statusUpdate = await updateOnboardingStatus("linkedAccount");
    if (!statusUpdate) {
      setErrorMessage(
        "There was an error updating your tier. If the problem persists please contact support.",
      );
      console.log("There was an error updating the onboarding status");
      return;
    }

    setTimeout(() => {
      setStep(8);
    }, 5000);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
 
    setLoading(true);
    const response = await AuthServices.updateStripeAccount( );
    if (!response.success) {
      setErrorMessage(
        "There was an error updating your tier. If the problem persists please contact support.",
      );
      return;
    }

    setAccountCreatePending(false);

    if (response.data.id) {
      setConnectedAccountId(response.data.id);
    }

    if (error) {
      setErrorMessage(
        "There was an error loading stipes dashboard. If the problem persists please contact support.",
      );
      setError(true);
      return;
    }

    setLoading(false);
  };

  return (
    <div className="stripe-connect-container">
      {!accountCreatePending && !connectedAccountId && (
        <div className="onboarding-header">
          <h2>Set up your payouts</h2>
          <p>
            Create your payout account so we can send your earnings directly to
            your bank.
          </p>
          <button onClick={(e) => handleSubmit(e)} className="choose-button">
            {loading ? "Starting onboarding..." : "Begin onboarding"}
          </button>
        </div>
      )}

      <div className="stripe-container">
        {stripeConnectInstance && (
          <ConnectComponentsProvider connectInstance={stripeConnectInstance}>
            <ConnectAccountOnboarding onExit={handleExit} />
          </ConnectComponentsProvider>
        )}

        {errorMessage && <p className="error-message">{errorMessage}</p>}
        {error && <p className="error">Something went wrong!</p>}

        {(connectedAccountId || accountCreatePending || onboardingExited) && (
          <div className="dev-callout">
            {connectedAccountId && (
              <p>
                Connected account created:{" "}
                <code className="bold">{connectedAccountId}</code>
              </p>
            )}
            {accountCreatePending && <p>Creating your payout account...</p>}
            {onboardingExited && (
              <p>Onboarding flow exited. You can resume at any time.</p>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default StripeSetup;
